var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/* istanbul ignore file */
import { english } from "../languages/English";
import { LanguageEnum } from "../infrastructure/LanguageEnum";
import { portuguese } from "../languages/Portuguese";
import { spanish } from "../languages/Spanish";
export var availableLanguages = [
    { code: LanguageEnum.SPANISH, name: "Español" },
    { code: LanguageEnum.ENGLISH, name: "English" },
    { code: LanguageEnum.PORTUGUESE, name: "Português" },
];
function mergeLanguages(defaultLanguage, translateOptions) {
    var result = defaultLanguage;
    translateOptions.forEach(function (translations) {
        Object.keys(translations).forEach(function (key) {
            // @ts-ignore
            if (Array.isArray(translations[key])) {
                // @ts-ignore
                result[key] = __spreadArrays(result[key].concat(translations[key]));
            }
            else {
                // @ts-ignore
                var subKeys = Object.keys(translations[key]);
                subKeys.forEach(function (subKey) {
                    // @ts-ignore
                    result[key][subKey] = __spreadArrays(result[key][subKey].concat(translations[key][subKey]));
                });
            }
            return;
        });
    });
    return result;
}
export var getAppTranslations = function () {
    return mergeLanguages(spanish, [english, portuguese]);
};
